module.exports = __webpack_public_path__ + "img/Health&Medicine.c560df57.png";